import { render, staticRenderFns } from "./HighlightedNewsNew.vue?vue&type=template&id=60bbf3f2&scoped=true&"
import script from "./HighlightedNewsNew.vue?vue&type=script&lang=js&"
export * from "./HighlightedNewsNew.vue?vue&type=script&lang=js&"
import style0 from "./HighlightedNewsNew.vue?vue&type=style&index=0&id=60bbf3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bbf3f2",
  null
  
)

export default component.exports